// extracted by mini-css-extract-plugin
module.exports = {"brandingWrapperDark":"branding_brandingWrapperDark__JiOHm","brandingWrapper":"branding_brandingWrapper__tbS80"};